import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {TrustiiService} from 'src/app/services/trustii.service';
import {DialogService} from 'src/app/services/dialog.service';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';

@Component({
  selector: 'app-password-confirmation',
  templateUrl: './password-confirmation.component.html',
  styleUrls: ['./password-confirmation.component.scss']
})
export class PasswordConfirmationComponent implements OnInit {
  resetSuccess = false;
  resetInProgress = false;
  key = '';
  private params: Params;

  constructor(
    private router: Router, private trustiiService: TrustiiService,
    private dialogService: DialogService, private route: ActivatedRoute
  ) {
    document.body.style.backgroundImage = 'url("/assets/img/TrustiiHomePage.png")';
    document.body.style.backgroundPosition = 'center center';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.backgroundSize = 'cover';
  }

  ngOnInit() {
    this._loadParams$()
      .pipe(
        tap(this.confirmResetPassword.bind(this))
      )
      .subscribe();
  }

  /** _loadParams$ method
   *
   * Load params and set class properties.
   * @return Observable<Params>
   */
  private _loadParams$(): Observable<Params> {
    return this.route.queryParams.pipe(
      map((params: Params) => this.params = params)
    );
  }

  confirmResetPassword() {
    if (!this.params.key) {
      this.router.navigateByUrl('');
    }

    this.resetInProgress = true;
    const payload = {
      key: this.params.key,
    };
    this.trustiiService.confirmResetPassword(payload).subscribe(res => {
      this.resetSuccess = true;
      this.resetInProgress = false;
    }, err => {
      this.resetInProgress = false;
      this.dialogService.openAlertDialog(
        '350px',
        'Failed to reset your password. Please try again later.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      this.router.navigateByUrl('');
    });

  }

  redirectToSignIn() {
    this.router.navigateByUrl('');
  }
}
